import { render } from "./ProgramDialog.vue?vue&type=template&id=3c00e482&scoped=true"
import script from "./ProgramDialog.vue?vue&type=script&lang=js"
export * from "./ProgramDialog.vue?vue&type=script&lang=js"

import "./ProgramDialog.vue?vue&type=style&index=0&id=3c00e482&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c00e482"]])

export default __exports__